<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="submit" class="btn btn-outline-success"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">        
        <h4 style="display:inline">Previa {{solicitudPreviaInspectorEx.CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />
                <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                <label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitudEx}}">{{solicitudPreviaInspectorEx.CodigoTipoSolicitud}}</label>
                <img class="estado-icono-big" container="body" src="{{solicitudPreviaInspectorEx.IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{solicitudPreviaInspectorEx.IdEstadoSolicitudExDescripcion}}" />
                <img *ngIf="solicitudPreviaInspectorEx?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || solicitudPreviaInspectorEx?.IdSubTipoSolicitudEx === reExpConAtestFito || solicitudPreviaInspectorEx?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{solicitudPreviaInspectorEx.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{solicitudPreviaInspectorEx.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudPreviaInspectorEx.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{solicitudPreviaInspectorEx.IdEstadoCertificadoFitoExDescripcion}}" />
                <img *ngIf="solicitudPreviaInspectorEx?.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{solicitudPreviaInspectorEx.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudPreviaInspectorEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="idSolicitudEx">
                    <app-alertarechazo [id]="idSolicitudEx" [esExport]="true"></app-alertarechazo>
                </ng-container>

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header"></div>

                    <div class="card-body-detalle">
                        <div class="row">

                            <div class="form-group col-md-6">
                                <label class="col-form-label" for="inpAceptada">¿Aceptar?</label>
                                <div class="ui-g">
                                    <div class="ui-g-3">
                                        <p-radioButton formControlName="Aceptada" inputStyleClass="form-control" name="Aceptada" value="S" label="Sí"></p-radioButton>
                                    </div>
                                    <div class="ui-g-3">
                                        <p-radioButton formControlName="Aceptada" inputStyleClass="form-control" name="Aceptada" value="N" label="NO"></p-radioButton>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpFecha">Fecha</label>
                                <p-calendar formControlName="Fecha" inputStyleClass="form-control" [ngClass]="displayFieldCssCal('Fecha')"
                                            [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Fecha','required')">
                                    Fecha es obligatoria
                                </div>
                            </div>

                        </div>

                        <div class="row" style="margin-bottom:15px;">

                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpCodigo">Observaciones</label>
                                <textarea style="resize:none" formControlName="Observaciones" maxlength="500" name="Observaciones" title="" class="form-control" inputStyleClass="form-control" type="text" value=""></textarea>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</form>
